import React, { useEffect } from 'react'
import parentStyles from '../styles.module.scss'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import { useSelector, useDispatch } from 'react-redux'
import Spinner from 'srcReact/components/common2/Spinner'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import { commonActions, commonConstants as cc } from 'srcReact/components'
import NoResultInSearch from '../../NoResultInSearch'

export default function Mobile({
  membersToInvite,
  lastMemberRef,
  search,
  goToSearchScreen,
  startConversation,
  removeMemberFromInvite,
  addMemberToInvite,
  showUserLightModal,
  isMemberAddedForInvitation,
  handleSearch,
  setIsNewConvOpen
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile },
    messenger: { searchedMembers, loadingInSidebar, searchedMemberError }
  } = useSelector((state) => state)

  const close = () => {
    setIsNewConvOpen(false)
    goToSearchScreen()
  }
  useEffect(() => {
    return () => {
      goToSearchScreen()
    }
  }, [])
  return (
    <div className={parentStyles.container}>
      <div className={styles.actions}>
        <Button style='' text={t('global.cancel')} customStyle={styles.actionCancel} handleClick={close} />
        <Button
          style=''
          text={t('messenger.btnCreate')}
          customStyle={styles.actionNext}
          handleClick={startConversation}
        />
      </div>
      <div className={styles.newConvTitle}>{t('messenger.newChat')}</div>
      {membersToInvite.length > 0 && (
        <div className={styles.addedMembers}>
          {membersToInvite.map((member) => (
            <div key={member.user_id} className={styles.addedMemberInList}>
              <div className={styles.avatarWithClose}>
                <div role='button' onClick={() => removeMemberFromInvite(member)} className={styles.closeButton}>
                  <Icon name='close24' styleModifier={styles.closeIcon} />
                </div>
                <Avatar
                  key={'member_' + member.user_id}
                  userId={member.user_id}
                  profilePicture={member.profile_picture_url}
                  firstname={member.firstname}
                  lastname={member.lastname}
                  imgWrapperSize='medium'
                  onClickAction={() => showUserLightModal(member)}
                  mimeType={member.mime_type}
                  originalTag={member.original_tag}
                  isOriginal={member.is_original}
                  withExpertiseGroup={member.with_expertise_group}
                />
              </div>

              <div className={`${styles.selectedMemberName}`}>{member.firstname}</div>
            </div>
          ))}
        </div>
      )}

      <SearchTextBox
        minimumSearchChar={2}
        {...(search?.length === 0 && { clear: true })}
        size='large'
        iconPosition='start'
        placeholder={t('formlabel.searchMemberPlaceholder1')}
        handleSearch={handleSearch}
        cssClass={`${parentStyles.searchContainer} ${styles.searchContainer}`}
        inputCssClass={parentStyles.inputCssClass}
      />
      {!loadingInSidebar && !searchedMemberError && search?.length >= 3 && searchedMembers.length === 0 && (
        <NoResultInSearch customCss={parentStyles.noresult} />
      )}
      <div className={`${parentStyles.list}  ${membersToInvite.length > 0 ? styles.listMaxHeight : styles.list}`}>
        {searchedMembers &&
          searchedMembers.length > 0 &&
          searchedMembers
            .filter((member) => !isMemberAddedForInvitation(membersToInvite, member))
            .map((member, index) => {
              const isLastMember = searchedMembers.length === index + 1

              return (
                <div
                  key={member.user_id}
                  ref={isLastMember ? lastMemberRef : null}
                  className={`${parentStyles.memberInList} ${styles.memberInList} `}>
                  <div className={parentStyles.memberInListInner}>
                    <Avatar
                      key={'member_' + member.user_id}
                      userId={member.user_id}
                      profilePicture={member.profile_picture_url}
                      firstname={member.firstname}
                      lastname={member.lastname}
                      imgWrapperSize='small'
                      onClickAction={() => showUserLightModal(member)}
                      mimeType={member.mime_type}
                      originalTag={member.original_tag}
                      isOriginal={member.is_original}
                      withExpertiseGroup={member.with_expertise_group}
                    />
                    <button
                      type='button'
                      onClick={() => addMemberToInvite(member)}
                      className={parentStyles.addRemoveIconButton}>
                      <div className={parentStyles.userProfile}>
                        <div className={styles.memberName}>
                          {member.firstname} {member.lastname}
                        </div>
                      </div>

                      <Icon name='add' size='large' styleModifier={parentStyles.addRemoveIcon} />
                    </button>
                  </div>
                </div>
              )
            })}
        {loadingInSidebar || (searchedMemberError && searchedMemberError === 'cancelTokenError') ? <Spinner /> : null}
      </div>
      <div className={parentStyles.finalLine}></div>
    </div>
  )
}
